<template>
<el-dialog center width="600px" title="编辑部门" :visible.sync="dialogFormVisible"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="部门名称" :label-width="formLabelWidth" prop="name">
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="部门编号" :label-width="formLabelWidth" prop="number">
        <el-input v-model="editForm.number" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="部门简称" :label-width="formLabelWidth" prop="short_name">
        <el-input v-model="editForm.short_name"  autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="部门性质" :label-width="formLabelWidth" prop="property">
        <el-input  v-model="editForm.property" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="负责人" :label-width="formLabelWidth" prop="duty_people">
        <el-input v-model="editForm.duty_people" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="电话号码" :label-width="formLabelWidth" prop="phone_num">
        <el-input v-model="editForm.phone_num" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分机号" :label-width="formLabelWidth" prop="exten_num">
        <el-input v-model="editForm.exten_num" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
        <el-input v-model="editForm.remark" type="textarea" :rows="2" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 导入接口
import { formData, formRules} from '../form.js'
export default {
  data() {
    return {
      dialogFormVisible: false,
      editForm: {...formData},
      editRules: formRules,
      formLabelWidth: "120px"
    };
  },
  methods: {
    submitEdit() {
      // 页面上面的 ref  和这里 点的 需要对应
      this.$refs.editForm.validate(valid => {
        if (valid) {
          window.console.log(valid)
        } else {
          this.$message.warning("格式不太对哦，检查一下");
          return false;
        }
      });
    }
  }
};
</script>

<style></style>
